import {
    GET_PRODUCT_INFO,
    FETCH_PRODUCT_COVERAGE,
    OPEN_COVERAGE_ACCORDION,
    OPEN_MODAL_QUOTATION_DATE_WARNING,
    CLOSE_MODAL_QUOTATION_DATE_WARNING,
    SET_USER_DETAILS,
    GET_INFOS_PROSPECT,
    OPEN_MODAL_QUOTATION_DATE_YEAR,
    CLOSE_MODAL_QUOTATION_DATE_YEAR,
} from './actionTypes'

export const getProductInfo = (productInfo) => ({
    type: GET_PRODUCT_INFO,
    productInfo,
})

export const fetchProductCoverage = (productCoverage) => ({
    type: FETCH_PRODUCT_COVERAGE,
    productCoverage,
})

export const openCoverageAccordion = (code) => ({
    type: OPEN_COVERAGE_ACCORDION,
    code,
})

export const openModalQuotationDateWarning = () => ({
    type: OPEN_MODAL_QUOTATION_DATE_WARNING
})

export const closeModalQuotationDateWarning = () => ({
    type: CLOSE_MODAL_QUOTATION_DATE_WARNING
})

export const setUserDetails = (data) => ({
    type: SET_USER_DETAILS,
    userDetails: data.user_details,
})

export const setInfosProspect = (infos) => ({
    type: GET_INFOS_PROSPECT,
    infos,
})

export const openModalQuotationDateYear = () => ({
    type: OPEN_MODAL_QUOTATION_DATE_YEAR
})

export const closeModalQuotationDateYear = () => ({
    type: CLOSE_MODAL_QUOTATION_DATE_YEAR
})



// WEBPACK FOOTER //
// ./src/actions/coverageActions.js